'use client';

import Script from 'next/script';

export default function YandexMapScript({ lang = 'ru' }) {
	const langCode = lang === 'ru' ? 'ru_RU' : 'en_US';
	const apiKey = process.env.APP_YANDEX_GEOCODE_API_KEY;

	return (
		<Script
			id='yandex-maps'
			src={`https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=${langCode}`}
			strategy='afterInteractive'
		/>
	);
}
